import { useAppSelector } from '@shared/hooks/useAppSelector'
import { RcFile } from 'antd/lib/upload'
import { useDispatch } from 'react-redux'
import { fetchEmployeeInfo } from 'store/actions/salaryCard'

export function useFetchEmployeeInfoExcel() {
  const dispatch = useDispatch()
  const salaryCardListExcelError = useAppSelector((state) => state.excelUploadSalaryCards.salaryCardListExcelError)
  const salaryCardListExcelStatus = useAppSelector((state) => state.excelUploadSalaryCards.salaryCardListExcelStatus)
  const salaryCardListExcel = useAppSelector((state) => state.excelUploadSalaryCards.salaryCardListExcel)

  const mutate = (file: RcFile) => {
    dispatch(fetchEmployeeInfo(file))
  }

  return {
    salaryCardListExcel,
    status: salaryCardListExcelStatus,
    error: salaryCardListExcelError,
    mutate,
  }
}
